export default __webpack_public_path__ + "static/media/wordIcon.c4e01bef.svg";